import { BaseAPI } from "@/api/base.api";
import { API_URL_SERVICE } from "@/commons/config";
import { AxiosObservable } from "axios-observable";

interface VehicleDataIntput {
  plate: string;
  transportId: number;
}

interface CompanyDataInput {
  cnpj: string;
}

export interface OrderVehicleInput {
  kind: string;
  data: VehicleDataIntput | CompanyDataInput;
}

export class OrderAPI extends BaseAPI<any> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/api_app/v1/solicitations`;
  }

  public list(params: any): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}`, { params: this.buildFiltered(params) })
  }

  public create(body: OrderVehicleInput): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}`, { ...body });
  }

  public bulkCreate(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/bulks`, { ...body });
  }

  public createVehicleExclusion(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/vehicle_exclusion`, { ...body });
  }

  public show(id: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/${id}`)
  }

  public showPublic(secretToken: string): AxiosObservable<any> {
    const apiUrl = `${API_URL_SERVICE}/api_app/v1`;
    return this.axios.get(`${apiUrl}/public/solicitations/${secretToken}`)
  }

  public payments(order_id: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/${order_id}/payments`)
  }

  public listStatus(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/statuses`);
  }

  public detailsPedidos(group: string): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/solicitations/?group=${group}`);
  }

  public detailsPedidosByGroup(group: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/solicitations/?group=${group}`);
  }

  public detailsListPayments(group: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/payments/?solicitation_group=${group}`
    );
  }

  public updateEvidences(key: string, formData: object) {
    return this.axios.patch(`${this.apiUrl}/requirements/${key}`, formData)
  }

  public upload(key: string, formData: object) {
    return this.axios.post(`${this.apiUrl}/requirements/${key}/upload`, formData)
  }

  public getByKey(key: string) {
    return this.axios.get(`${this.apiUrl}/requirements/${key}`)
  }

  public contentDetach(key: string) {
    return this.axios.delete(`${this.apiUrl}/requirements/${key}/content_detach`)
  }

  public showPaymentsGroup(group: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/payments/?solicitation_group=${group}`
    );
  }

  public createAutovistoria(
    solicitaionId: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections`,
      body
    );
  }
  public getAllAutovistoria(solicitaionId: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections`
    );
  }
  public detailsAutovistoria(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}`
    );
  }
  public updateApproveImages(
    solicitaionId: string,
    inspectionKey: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/requirements/${key}`,
      body
    );
  }
  public updateVehicleInformation(
    solicitaionId: string,
    inspectionKey: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/vehicles/${key}`,
      body
    );
  }
  public deferAutovistoria(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/defer`
    );
  }
  public denyAutovistoria(
    solicitaionId: string,
    key: string,
    reject_reason: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/deny`, { reject_reason }
    );
  }
  public updateItemChecklist(
    solicitaionId: string,
    inspectionKey: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/checklist_items/${key}`,
      body
    );
  }

  public finishChecklist(
    solicitaionId: string,
    inspectionKey: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/checklist/${key}/finish`
    );
  }

  public resendAutovistoria(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/resend`
    );
  }

  public sendEvidenceRefusend(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/send_refuseds`
    );
  }

  public updateAutovistoria(
    solicitaionId: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}`,
      body
    );
  }

  public generateReport(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/reports/generate_original`
    );
  }

  public uploadReport(
    solicitaionId: string,
    key: string,
    content: File
  ): AxiosObservable<any> {

    let formData = new FormData();
    formData.append("content", content);

    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/reports/upload_signed`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  }

  public cancel(id: number, reason: string): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/cancel`, { reason });
  }

  public analyse(id: number): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/analyze`);
  }

  public approve(id: number): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/approve`);
  }

  public refuse(id: number, reason: string): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/refuse`, { reason });
  }

  public pending(id: number): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/pending`);
  }

  public listDocuments(orderId: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/solicitations/${orderId}/documents`);
  }

  public listDocumentsPublic(secretToken: string): AxiosObservable<any> {
    const apiUrl = `${API_URL_SERVICE}/api_app/v1`;
    return this.axios.get(`${apiUrl}/public/solicitations/${secretToken}/documents`);
  }

  public createCompanyRegistrationRenewal(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/company_registration_renewal`, { ...body });
  }

  public createCompanyRegistration(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/company_registration`, { ...body });
  }

  public createVehicleInclusion(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/vehicle_inclusion`, { ...body });
  }
}
